<div id="enrollment-agreement">
  <div class="page1 p-3">

    <!-- Shared header: logo + studio info from config -->
    <p class="text-center mb-1"><img style="max-width:250px;" src="assets/images/AMDCBlackHorizontalJPG.jpg" /></p>
    <p class="text-center small mb-0">
      {{ this.studioInformationConfig?.field_studio_address?.[0]?.address_line1 }}
      {{ this.studioInformationConfig?.field_studio_address?.[0]?.locality }},
      {{ this.studioInformationConfig?.field_studio_address?.[0]?.administrative_area }}
      {{ this.studioInformationConfig?.field_studio_address?.[0]?.postal_code }}
    </p>
    <p class="text-center small mb-3">
      Phone: {{ this.studioInformationConfig?.field_studio_phone_number?.[0]?.value }}
      <span class="ms-3 text-decoration-underline">{{ this.studioInformationConfig?.field_studio_website?.[0]?.uri }}</span>
    </p>

    <!-- Shared student info -->
    <div class="d-flex border-bottom pb-1 mb-2" style="max-width:320px;">
      <span class="fw-bold me-2">Date:</span>
      <span>{{ (this.entityData?.['field_sale_date']?.value || this.entityData?.['field_sale_date']) | date }}</span>
    </div>
    <div class="d-flex border-bottom pb-1 mb-2">
      <span class="fw-bold me-2">Student Name:</span>
      <span>{{ entityData?.['field_student']?.['title'] || '' }}</span>
    </div>
    <div class="d-flex border-bottom pb-1 mb-2">
      <span class="fw-bold me-2">Address:</span>
      <span>{{ primaryContact?.field_address?.address_line1 || '' }}</span>
    </div>
    <div class="d-flex gap-4 border-bottom pb-1 mb-2">
      <div class="flex-grow-1">
        <span class="fw-bold me-1">City:</span>
        <span>{{ primaryContact?.field_address?.locality || '' }}</span>
      </div>
      <div class="flex-grow-1">
        <span class="fw-bold me-1">Postal Code:</span>
        <span>{{ primaryContact?.field_address?.postal_code || '' }}</span>
      </div>
    </div>
    <div class="d-flex gap-4 border-bottom pb-1 mb-2">
      <div class="flex-grow-1">
        <span class="fw-bold me-1">Phone:</span>
        <span>{{ primaryContact?.field_cell_phone || '' }}</span>
      </div>
      <div class="flex-grow-1">
        <span class="fw-bold me-1">Alternate:</span>
        <span></span>
      </div>
    </div>
    <div class="d-flex border-bottom pb-1 mb-3" style="max-width:420px;">
      <span class="fw-bold me-2">Email:</span>
      <span>{{ primaryContact?.field_email || '' }}</span>
    </div>

    <!-- ============ PROGRAM FORM (Original / Service) ============ -->
    <ng-container *ngIf="!isExtensionOrRenewal">

      <h4 class="fw-bold mb-3 ms-4">{{ getPackageName() || 'Introductory Program' }}</h4>

      <div class="mb-3" style="max-width:560px;">
        <div class="d-flex justify-content-between">
          <span class="fw-bold">{{ entityData?.['field_enrollment_lesson_count'] || '' }} Private Lessons</span>
          <span class="fw-bold">${{ getOriginalPackageCost() | number:'1.2-2' }}</span>
        </div>

        <div class="d-flex justify-content-between mt-3" *ngIf="getDiscountAmount() > 0">
          <span class="fw-bold">Discount</span>
          <span class="fw-bold">${{ getDiscountAmount() | number:'1.2-2' }}</span>
        </div>

        <div class="d-flex justify-content-between mt-3">
          <span class="fw-bold">Subtotal</span>
          <span class="fw-bold">${{ getSubtotal() | number:'1.2-2' }}</span>
        </div>
        <div class="d-flex justify-content-between">
          <span class="fw-bold">{{ taxLabel }}</span>
          <span class="fw-bold">${{ getGstAmount() | number:'1.2-2' }}</span>
        </div>

        <div class="d-flex justify-content-between mt-3">
          <span class="fw-bold">Total</span>
          <span class="fw-bold">${{ calculateTotalTuition() | number:'1.2-2' }}</span>
        </div>
      </div>

      <div class="d-flex border-bottom pb-1 mb-3" *ngIf="getNotes()">
        <span class="fw-bold me-2 text-nowrap">Notes:</span>
        <span class="fst-italic">{{ getNotes() }}</span>
      </div>

      <div *ngIf="isInstallmentAgreement && allPaymentRows.length" class="mb-3" style="max-width:420px;">
        <p class="small fw-bold mb-1">Payment schedule:</p>
        <ng-container *ngIf="areAllPaymentAmountsSame(); else detailedProgramPayments">
          <table class="table table-bordered text-center small mb-1">
            <tr><th>Number of Payments</th><th>Amount of Payments</th><th>Payments Due</th></tr>
            <tr>
              <td>{{ allPaymentRows.length }}</td>
              <td>${{ allPaymentRows[0].amount | number:'1.2-2' }}</td>
              <td>{{ firstPaymentDate ? (firstPaymentDate | date) : 'Not specified' }}</td>
            </tr>
          </table>
        </ng-container>
        <ng-template #detailedProgramPayments>
          <table class="table table-bordered text-center small mb-1">
            <tr><th>Payment #</th><th>Amount</th><th>Due Date</th></tr>
            <tr *ngFor="let payment of allPaymentRows; let i = index">
              <td>{{ i + 1 }}</td>
              <td>${{ payment.amount | number:'1.2-2' }}</td>
              <td>{{ payment.date ? (payment.date | date) : '' }}</td>
            </tr>
          </table>
        </ng-template>
        <p class="small mb-0">Payments due as scheduled above, until paid in full.</p>
      </div>

      <div class="d-flex gap-4 border-top pt-2 mb-1">
        <div class="flex-grow-1">
          <span class="fw-bold me-1">Expiry Date:</span>
          <span class="fw-bold">{{ expirationDate ? (expirationDate | date) : '' }}</span>
        </div>
        <div class="flex-grow-1">
          <span class="fw-bold me-1">Teacher:</span>
          <span>{{ entityData?.field_executive?.title || '' }}</span>
        </div>
      </div>
      <p class="small mb-1">It is agreed that the Studio's obligation for finishing instructions under this agreement shall expire on the "Expiry Date" noted above.</p>
      <p class="fw-bold mb-2">{{ (getPackageName() || 'THIS PROGRAM') | uppercase }} IS NON-REFUNDABLE</p>

    </ng-container>

    <!-- ============ EXTENSION / RENEWAL FORM (HT-AM 400-B Alberta) ============ -->
    <ng-container *ngIf="isExtensionOrRenewal">

      <p class="fw-bold text-center small mb-3">LESSONS ARE 45 MINUTES WHICH INCLUDES TRANSITION TIME BETWEEN LESSON</p>

      <div class="d-flex gap-4 border-bottom pb-1 mb-2">
        <div class="flex-grow-1">
          <span class="fw-bold me-1">Type of Service(s):</span>
          <span>{{ getPackageName() }}</span>
        </div>
        <div class="flex-grow-1">
          <span class="fw-bold me-1">Number of Lessons:</span>
          <span>{{ getLessonCount() }}</span>
        </div>
      </div>
      <div class="d-flex border-bottom pb-1 mb-3" *ngIf="getNotes()">
        <span class="fw-bold me-2 text-nowrap">Notes:</span>
        <span class="fst-italic">{{ getNotes() }}</span>
      </div>

      <div class="row mb-2">
        <div class="col-6 small">
          <div class="d-flex justify-content-between border-bottom mb-2">
            <span>1. Cash Price of This Course ..........................</span>
            <span class="text-nowrap ms-2">${{ calculateTotalTuition() | number:'1.2-2' }}</span>
          </div>
          <div class="d-flex justify-content-between border-bottom mb-2">
            <span>2. Outstanding Balance of Previous Agreement ..........</span>
            <span class="text-nowrap ms-2">${{ getOutstandingBalance() | number:'1.2-2' }}</span>
          </div>
          <div class="d-flex justify-content-between border-bottom mb-2">
            <span>3. Consolidated Cash Price (1+2) .....................</span>
            <span class="text-nowrap ms-2">${{ getConsolidatedCashPrice() | number:'1.2-2' }}</span>
          </div>
          <div class="d-flex justify-content-between border-bottom mb-2">
            <span>4. Cash Down Payment of ..............................</span>
            <span class="text-nowrap ms-2">${{ getDownPaymentAmount() | number:'1.2-2' }}</span>
          </div>
          <div class="d-flex justify-content-between border-bottom mb-2">
            <span>5. Balance to be Financed (3-4) ......................</span>
            <span class="text-nowrap ms-2">${{ getBalanceToFinance() | number:'1.2-2' }}</span>
          </div>
        </div>
        <div class="col-6 small">
          <p class="mb-1">Total Sale Price: The total cost of your purchase on credit, including your down payment of <span class="fw-bold">${{ getDownPaymentAmount() | number:'1.2-2' }}</span></p>
          <p class="text-end fw-bold mb-2">TOTAL ${{ getConsolidatedCashPrice() | number:'1.2-2' }}</p>

          <ng-container *ngIf="areAllPaymentAmountsSame(); else detailedFinancedPayments">
            <table class="table table-bordered text-center small mb-1">
              <tr>
                <th>No. of Pymts</th>
                <th>Amount of Payments</th>
                <th>Monthly Beginning</th>
                <th>Pymt Method</th>
              </tr>
              <tr>
                <td>{{ allPaymentRows.length || '' }}</td>
                <td>{{ allPaymentRows.length ? ('$' + (allPaymentRows[0].amount | number:'1.2-2')) : '$' }}</td>
                <td>{{ firstPaymentDate ? (firstPaymentDate | date) : '' }}</td>
                <td></td>
              </tr>
            </table>
          </ng-container>
          <ng-template #detailedFinancedPayments>
            <table class="table table-bordered text-center small mb-1">
              <tr>
                <th>Pymt #</th>
                <th>Amount</th>
                <th>Due Date</th>
                <th>Pymt Method</th>
              </tr>
              <tr *ngFor="let payment of allPaymentRows; let i = index">
                <td>{{ i + 1 }}</td>
                <td>${{ payment.amount | number:'1.2-2' }}</td>
                <td>{{ payment.date ? (payment.date | date) : '' }}</td>
                <td></td>
              </tr>
            </table>
          </ng-template>
          <p class="mb-0">and on the same date each month thereafter until paid in full.</p>
        </div>
      </div>

      <!-- Terms A–J -->
      <div class="small mb-2" style="font-size:0.72rem;">
        <p class="mb-1">A. The Studio agrees to provide this course of instruction and/or services in accordance with the Arthur Murray&reg; method of dance instruction and to make its facilities and personnel available by individual independent appointment for each lesson or service for such purposes during the term of this agreement. The Studio may provide the Student with any instructor employed by the Studio and is not obligated to provide any specific instructor nor to provide the same instructor for different lessons.</p>
        <p class="mb-1">B. Instructions shall be available commencing this date and shall not be charged against this enrollment until the completion of all previous enrollments, if any.</p>
        <p class="mb-1">C. Student agrees to complete all lessons and/or services as expressly provided in this agreement. Student shall not be relieved of the obligation to make any payment agreed to, and no deduction or allowance for any payments shall be made by reason of Student's failure to use any lessons and/or services, except as provided.</p>
        <p class="mb-1">D. If this agreement is cancelled within three business days, the Studio will refund all payments made under the agreement. After three business days, the Studio will only charge you for the dance instructions and dance instruction services actually furnished under the agreement plus a reasonable and fair service fee.</p>
        <p class="mb-1">E. "Notice of cancellation" shall be deemed to have been provided by a Student or prospective Student by mailing or delivering written notification to cancel the contract or written agreement. After the expiration of the term of this agreement, refunds will not be granted.</p>
        <p class="mb-1">F. Student agrees to notify the Studio at least 12 hours in advance to cancel or change any private appointment or be charged for such lessons.</p>
        <p class="mb-1">G. Student lessons may be transferred to any other Arthur Murray&reg; Franchised Dance Studio beyond twenty-five miles from this Studio.</p>
        <p class="mb-1">H. Student represents to the Studio that (s)he is physically able to take and financially able to pay for this course of instruction and/or services, has read and fully understands the terms of this agreement, has signed the agreement voluntarily and hereby acknowledges receipt of a fully executed copy.</p>
        <p class="mb-1">I. AS STUDENT, I UNDERSTAND AND AGREE THAT THIS AGREEMENT IS MADE BY ME SOLELY WITH THE OWNER OF THE STUDIO, AS SELLER, AND DOES NOT DIRECTLY OR INDIRECTLY CONSTITUTE AN AGREEMENT WITH OR AN OBLIGATION OF ARTHUR MURRAY INTERNATIONAL, INC., OR AS THE STUDIO FRANCHISOR. ARTHUR MURRAY INTERNATIONAL, INC. IS NOT THE OWNER OF THIS STUDIO.</p>
        <p class="mb-1">J. No other representations or provisions, either written or oral, are a part of this agreement, unless expressed herein.</p>
      </div>

      <p class="small fst-italic border-top border-bottom py-1 mb-2">It is agreed that the Studio's obligation for furnishing instructions under this agreement shall expire on the "Expiry Date" noted above or two years from the date of this agreement whichever occurs first. <span class="fw-bold ms-2">Expiry Date: {{ expirationDate ? (expirationDate | date) : '____________' }}</span></p>

    </ng-container>

    <!-- Shared signature area -->
    <div class="row" *ngIf="displaySigned">
      <div class="col-6">
        <p class="small mb-2">Signed this <span class="fw-bold">{{ (this.entityData?.['field_sale_date']?.value || this.entityData?.['field_sale_date']) | date }}</span></p>
        <p class="small mb-0">By:</p>
        <div class="border-bottom" style="height:30px;">
          <img *ngIf="displaySignatures && (_enrollmentEntityData?.['field_representative_signature']?.[0]?.['url'] || entityData?.field_representative_signature?.url)"
               class="img-fluid" style="max-height:28px;"
               [src]="_enrollmentEntityData?.['field_representative_signature']?.[0]?.['url'] || entityData?.field_representative_signature?.url" />
        </div>
        <small class="text-muted">Studio Representative</small>
      </div>
      <div class="col-6">
        <div class="border-bottom mt-4" style="height:30px;">
          <img *ngIf="displaySignatures && (_enrollmentEntityData?.['field_signature']?.[0]?.['url'] || entityData?.field_signature?.url)"
               class="img-fluid" style="max-height:28px;"
               [src]="_enrollmentEntityData?.['field_signature']?.[0]?.['url'] || entityData?.field_signature?.url" />
        </div>
        <small class="text-muted d-block mb-2">Student Signature</small>
        <ng-container *ngIf="isExtensionOrRenewal">
          <div class="border-bottom" style="height:30px;">
            <img *ngIf="displaySignatures && _enrollmentEntityData?.['field_parent_guardian_signature']?.[0]?.['url']"
                 class="img-fluid" style="max-height:28px;"
                 [src]="_enrollmentEntityData?.['field_parent_guardian_signature']?.[0]?.['url']" />
          </div>
          <small class="text-muted">Co-Student or Guardian</small>
        </ng-container>
      </div>
    </div>

  </div>

  <!-- The Waiver of Liability back page is generated by
       getEnrollmentAgreementBackpageContent() (enrollment-agreement-backpage.content.ts)
       and rendered/printed after this agreement, same as the other templates. -->
</div>
